<template>
  <div class="dataTableField">
    <table v-if="ready">
      <thead>
        <tr>
         <th v-for="(header, index) in dataOption.header" :key="index" v-html="header">
         </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(option, index) in currentValues" :key="index">
          <td class="left-option">
            <textarea class="browser-default" :placeholder="dataOption && dataOption.add_placeholder ? dataOption.add_placeholder  : 'Other Reason'"  @input="$_noOther($event, index)" v-model="currentValues[index].reason" :disabled="!option.added || globalDisabled"/>
          </td>
          <td class="right-option">
            <button v-if="option.added" v-tipped data-tooltip="Delete Entry"  :disabled="globalDisabled" @click="removeItem(index)" class="btn-floating btn-small btn-flat waves-effect right removeBtton">
              <i class="material-icons-outlined grey-text text-darken-4">delete</i>
            </button>
            <input type="number" :disabled="globalDisabled" v-model="currentValues[index].total" @input="updateValues($event, option.total)">
          </td>
        </tr>
        <tr v-if="dataOption.can_add">
          <td>
            <span v-html="dataOption.other_label ? dataOption.other_label : 'Other(state with numbers)'"></span>
          </td>
          <td class="center">
            <button :disabled="globalDisabled" @click="insertNewValue" class="btn waves-effect rounded z-depth-0">
             <i class="material-icons-outlined white-text left">add</i> {{dataOption.add_button_caption ? dataOption.add_button_caption : 'Add Other'}}
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="dataOption.show_total ">
        <tr>
          <td v-if="dataOption.total_option_label">
            <span v-html="dataOption.total_option_label"></span>
          </td>
          <td v-else>Total</td>
          <td>{{totalValues}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
export default {
  name:'dataTableField',
  props:{
    globalDisabled:{
      type:Boolean,
      default:false,
    },
    dataOption:{
      type:[Array, Object]
    }
  },
  data () {
    return {
      ready: false,
      currentValues: []
    }
  },
  mounted(){
    this.currentValues = this.dataOption.values
    setTimeout(() => {
      this.ready = true
    }, 49);
  }, 
  computed:{
    totalValues () {
      return this.currentValues.length > 0 && this.ready
      ? this.currentValues.map(({total}) => {return total || 0}).reduce((a,b) => parseFloat(a) + parseFloat(b))
      : 0
    }
  },
  methods:{
    insertNewValue () {
      this.currentValues.push({
        reason:'',
        added:true,
        total: "0"
      })
    /*   this.updateValues() */
    },
    $_noOther(evt, index) {
      if(evt.target.value.toLowerCase().trim() === 'other') this.currentValues[index].reason = ''
    },
    removeItem(index) {
      this.currentValues.splice(index, 1)
      this.updateValues()
    },
    updateValues () {
      this.$emit('update', { key:this.dataOption.name, value: this.currentValues } )
    }
  },
 
}
</script>
<style scoped lang="scss">
.dataTableField {
  margin: 12px 0px;
  border: 1px solid rgba(0, 0, 0, 0.19);
  border-radius: 12px;
  overflow: hidden;
  input[type="text"]:disabled {
    border-bottom: none !important;
  }
  input[type="number"] {
    float: right;
  }
  table {
    thead {
      tr {
        th {
          background: rgba(0,0,0,0.03);
        }
      }
    }
    th, td {
      padding: 10px 15px;
      border-right: 1px solid rgba(0,0,0,0.09);
    }
  }
}
.removeBtton {
  margin: 8px 0 10px 12px;
}
</style>